import { Pipe} from "@angular/core";

// @Pipe({name: "sortBy"})
// export class SortPipe {
//     transform(array: Array<string>, args: string): Array<string> {
//         array.sort((a: any, b: any) => {
//             if ( a[args] < b[args] ){
//                 return -1;
//             }else if( a[args] > b[args] ){
//                 return 1;
//             }else{
//                 return 0;
//             }
//         });
//         return array;
//     }
// }

@Pipe({name: 'orderBy', pure: false})

export class SortPipe {

    transform(array: Array<Object>, args: string): Array<Object> {

        console.log("calling pipe");

        if (array == null) {
            return null;
        }

        array.sort((a: any, b: any) => {
            if (a[args] < b[args] ){
                //a is the Object and args is the orderBy condition (data.likes.count in this case)
                return -1;
            }else if( a[args] > b[args] ){
                return 1;
            }else{
                return 0;
            }
        });
        return array;
    }
}


// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/shared/utils/sortBy-pipe.ts